import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { EmblemModel } from "@/features/emblems/api/models/EmblemModel";

export interface SetEmblemRequestModel {
	readonly emblemId: string;
}

export const useSetUserEmblem = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<EmblemModel>, SetEmblemRequestModel> = requestModel => {
		return http<EmblemModel, SetEmblemRequestModel>({
			method: "POST",
			url: "/emblem/active",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: data => {
			queryClient.setQueryData(["emblem"], data.body);
		}
	});
};
